import { ApplicationConfig } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { uriInterceptor } from './interceptors/uri.interceptor';
import { paramModificationInterceptor } from './interceptors/param-modification/param-modification.interceptor';
import { provideHighlightOptions } from 'ngx-highlightjs';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([uriInterceptor,
      paramModificationInterceptor
    ])),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHighlightOptions({
      fullLibraryLoader: () => import('highlight.js'),
    }),
  ]

};
  

